import { vuexTypes } from '../types'
import { ownersService } from '@api/owners.service'

const state = {
  owners: []
}

const mutations = {
  SET_LIST_OWNERS (state, list) {
    state.owners = list
  }
}

const actions = {
  async GET_LIST_OWNERS ({ commit }, data) {
    const listOwners = await ownersService.getOwnerList(data)
    if (listOwners._parsedData) {
      commit(vuexTypes.SET_LIST_OWNERS, listOwners._parsedData._embedded.records)
    } else {
      commit(vuexTypes.SET_LIST_OWNERS, {})
    }
  }
}

const getters = {
  ownersList: state => state.owners
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tokenowners.module.js